module.exports = __webpack_public_path__ + "img/cancel.1a3ad61b.png";